import React from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes, { array, object } from 'prop-types'

import { convertPrice, convertPriceWithoutCurrency } from '~/utils'
import { DashLine, FoodItemTopping } from '~/components'
import { useSelector } from 'react-redux'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { EXTERNAL_PARTNER, NEC_ERROR } from '~/constants'
import { useTranslation } from 'react-i18next'

// Dùng chung cho nhiều màn
const FoodItemOrder = ({
  foodOptionTypes = [],
  quantity,
  name,
  note,
  price,
  color = '#000',
  disableDashline = false,
  vat_amount = 0,
  dataFood = {},
}) => {
  const { externalPartner } = useSelector(selectRestaurant)
  const { t } = useTranslation()

  const renderNECErrors = () => {
    const { nec_errors } = dataFood || ''
    if (!nec_errors) return null
    return (
      <Typography
        textAlign="right"
        style={{ maxWidth: '45%' }}
        color={color}
        marginTop="10px"
        fontSize="1.4rem"
        fontWeight="500"
        lineHeight="1.8rem">
        {nec_errors === NEC_ERROR.OUT_OF_STOCK ? t('errors.errorOutOfStockNEC') : nec_errors}
      </Typography>
    )
  }
  return (
    <>
      <Box marginTop="20px" marginBottom="6px" display="flex" justifyContent="space-between">
        <Box width="100%">
          <Box display="flex" alignItems="flex-start" justifyContent="space-between">
            <Typography
              color={color}
              marginBottom="10px"
              component="h3"
              fontSize="1.8rem"
              fontWeight="500"
              lineHeight="2.2rem">
              {name}
            </Typography>
            <Typography
              lineHeight="1.1"
              color={color}
              minWidth="30px"
              textAlign="right"
              fontSize="1.8rem"
              fontWeight="400"
              component="div">
              x{quantity}
            </Typography>
          </Box>
          <FoodItemTopping color={color} foodOptionTypes={foodOptionTypes} />
          {note && (
            <Typography color={color} marginTop="8px" fontStyle="italic" fontSize="1.4rem">
              {note}
            </Typography>
          )}
          <Box justifyContent="space-between" flexDirection="row" display="flex">
            <Typography
              color={color}
              marginTop="10px"
              fontSize="1.4rem"
              fontWeight="500"
              lineHeight="1.8rem">
              {convertPrice(price)}{' '}
              {externalPartner !== EXTERNAL_PARTNER.Smaregi && vat_amount > 0
                ? `(${convertPriceWithoutCurrency(vat_amount)} VAT)`
                : ''}
            </Typography>
            {renderNECErrors()}
          </Box>
        </Box>
      </Box>

      {!disableDashline && (
        <Box marginTop="20px">
          <DashLine color={color} />
        </Box>
      )}
    </>
  )
}

export default React.memo(FoodItemOrder)

FoodItemOrder.defaultProps = {
  foodOptionTypes: [],
  quantity: 0,
  name: '',
  note: '',
  price: 0,
  color: '',
  disableDashline: false,
  vat_amount: 0,
}

FoodItemOrder.propTypes = {
  foodOptionTypes: PropTypes.oneOfType([object, array]),
  quantity: PropTypes.number,
  name: PropTypes.string,
  note: PropTypes.string,
  price: PropTypes.number,
  color: PropTypes.string,
  disableDashline: PropTypes.bool,
  vat_amount: PropTypes.number,
  dataFood: PropTypes.object,
}
